import {
  GeoJSON,
  KML,
} from 'ol/format'
import {
  bbox as bboxStrategy,
  tile as tileStrategy,
} from 'ol/loadingstrategy'
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { createEsriLoader } from '../loaders/esriLoader'
import { createXYZ } from 'ol/tilegrid'
import { getStandardLayerProps } from './utils'

export function createVectorLayer(config) {
  let source

  switch (config.type) {
    case 'geojson':
      source = new VectorSource({
        url: config.url,
        format: new GeoJSON(),
        ...config.source,
      })
      break

    case 'wfs':
      source = new VectorSource({
        format: new GeoJSON(),
        url: extent =>
          `${config.url}service=WFS&request=GetFeature&typename=${config.typename}&bbox=${extent.join(',')},EPSG:3857&outputFormat=application/json`,
        strategy: bboxStrategy,
        ...config.source,
      })
      break

    case 'esriFeature':
      source = new VectorSource({
        ...config.source,
        loader: createEsriLoader({
          serviceUrl: config.url,
          layer: config.layers,
        }),
        strategy: tileStrategy(
          createXYZ({ tileSize: 512 }),
        ),
      })
      break

    case 'kml':
      source = new VectorSource({
        ...config.source,
        url: config.url,
        format: new KML({
          crossOrigin: null,
        }),
      })
      break
  }

  return new VectorLayer({
    ...getStandardLayerProps(config),
    source,
  })
}
